export const environment= {
    production: false,
    HTTP:'https://alcp-preprod.qubeposcloud-uatapi.com/api/central',
    appVersion: 'v2.0.0.0',
    baseHref: '/alcp',
    qcURL: 'https://qubeconnect-preprod.qubeposcloud-uat.com/qubeconnect/',
    qubeconnectAPI: 'https://qubeconnect-preprod.qubeposcloud-uat.com/qubeconnect/gateway.php?path=',
    isQubeconnect: false,
    gatewaySignatureQubeConnect: "4ba86b860c91acedd6c319253277c115718b77996781d0772a882313eb2cd8fc",
    DEMO: 'PREPROD'
  }